<template>
  <!-- Mirrors UiCardProduct's shell (rounded-2xl, border, shadow) so the grid
       does not shift when real cards replace the skeletons. -->
  <div
    class="w-full h-full flex flex-col bg-white border border-gray-50 shadow-[0_8px_30px_rgb(0,0,0,0.04)] rounded-2xl overflow-hidden animate-pulse"
  >
    <!-- Media placeholder (matches default square media) -->
    <div class="w-full aspect-square bg-gray-100"></div>
    <!-- Text placeholder -->
    <div class="w-full flex-1 flex flex-col p-4 md:p-6 lg:p-8 gap-2">
      <div class="h-4 md:h-[18px] w-4/5 bg-gray-100 rounded"></div>
      <div class="h-4 md:h-[18px] w-3/5 bg-gray-100 rounded"></div>
      <div class="h-3 w-2/5 bg-gray-100 rounded mt-1.5"></div>
    </div>
  </div>
</template>

<script setup>
// Presentational skeleton, no props.
</script>
